const stressFactors = [
    //D typeoverlooked
    {
        desc:
        [`👾 Taking away ability to make decisions and take charge; sense of control`,
        `👾 Not taking action and getting started; nonsense and wasting time`,
        `👾 If it’s too easy, it’s not a challenge; no challenge, no stimulation`,
        `👾 Small details – especially if it’s routine work involving the minute details`,
        `👾 Silly mistakes that could’ve been corrected `],
 
        action:[
        `Blame others`,
        `Single out scapegoats`,
        `Become ever more demanding – what they expect from themselves they expect of others`,
        `Closed-off and burrows into the task at hand`],
 
        help:[
        `Suggest getting out there and getting some physical exercise – burn off the frustration`,
        `Give them something they can compete and win at`]
    },
     //I type
     {
        desc:
        [`👾 The impression they cannot be heard or seen; ignored and overlooked`,
        `👾 Negativity and any skepticism`,
        `👾 Structure; routine schedules and the mundane task`,
       `👾  Working alone; absence of a talking partner`,
        `👾 Seriousness; not being able to throw a joke out`,
        `👾 Negative feedback, especially in presence of others`],
 
        action:[
        `May draw attention to themselves when stressed`,
        `Actively loom for attention which results in talking and being the center of everything`,
        ],
 
        help:[
            `Let them organize something social`,
            `Don’t let them sink into their misery – talk to them`
        ]
    },
     //S type
     {
        desc:
        [`👾 Asked to do something they’ve never done`,
        `👾 Left alone in a meeting without support or relevant knowledge on subject at hand`,
        `👾 Incomplete tasks; a puzzle with 4 pieces left (loose ends)`,
       `👾 Not allowed private space; put into the spotlight`,
        `👾 Quick, unexpected changes`,
        `👾 Disagreements and negative feedback; conflicts`],
 
        action:[
            `Becomes reserved, closed-off`,
            `Refuse to change to those around them; provoke`,
        ],
 
        help:[
            `Give them their privacy and let them go off and do their “thing” / R&R`
        ]
    },
     //C type
     {
        desc:
        [`👾 Claiming they don’t know their subject`,
        `👾 Lack of plan or structure; order`,
        `👾 Ignoring logic reasoning or procedure`,
       `👾 “the in-laws are coming over, unannounced, right now!”`,
        `👾 Dramatic, talkative and emotional crowds`],
 
        action:[
            `Becomes pessimistic`,
            `Lethargic and bickering`,
            `Stomps on the brakes`,
        ],
 
        help:[
            `Give them their time and psychological distance to be alone with time to reflect and analyze`,
            `Once they’ve calculated how to more forward, they’ll spring back`
        ]
    }

]

export { stressFactors }
